enum AccordionItemAriaDisabledEnum {
	true = 'true',
	false = 'false'
}

export default AccordionItemAriaDisabledEnum;
